/* Native Shopify contact form. No submit interception or external data transfer. */
if (!customElements.get('artema-inquiry')) {
 customElements.define('artema-inquiry', class extends HTMLElement {
  connectedCallback() {
   if (this._controller) return;
   this._controller = new AbortController();
   const options = {signal:this._controller.signal};
   const init = () => {
    if (this._initialized || !this.isConnected) return;
    this._initialized = true;
    const params = new URLSearchParams(location.search);
    const type = this.querySelector('[data-inquiry-type]');
    const optional = this.querySelector('[data-optional-details]');
    const allowed = ['general','white-label','trade','arhitecti','nesigur','shop','showroom'];
    const aliases = {'personalizare':'general','vizită showroom':'showroom','vizita showroom':'showroom','hospitality':'general','corporate':'general','productie':'general'};
    const language = document.documentElement.lang.toLowerCase().slice(0,2);
    const copy = {
     ro:{reference:'Mă interesează un proiect similar: ',sku:'Cod ',hospitality:'Contract & Hospitality',corporate:'Corporate & evenimente',productie:'Producție & agenții',showroom:'Vizită showroom'},
     en:{reference:'I am interested in a similar project: ',sku:'SKU ',hospitality:'Contract & Hospitality',corporate:'Corporate & events',productie:'Production & agencies',showroom:'Showroom visit'},
     fr:{reference:'Je souhaite un projet similaire : ',sku:'Réf. ',hospitality:'Hôtellerie & espaces commerciaux',corporate:'Entreprises & événements',productie:'Fabrication & agences',showroom:'Visite au showroom'}
    }[language] || {reference:'I am interested in a similar project: ',sku:'SKU ',showroom:'Showroom visit'};
    const requested = (params.get('tip') || this.dataset.defaultType || 'general').trim();
    const normalized = requested.toLowerCase();
    const resolved = allowed.includes(normalized) ? normalized : (aliases[normalized] || (allowed.includes(this.dataset.defaultType) ? this.dataset.defaultType : 'general'));
    if(type && resolved==='showroom' && !type.querySelector('option[value="showroom"]')) type.add(new Option(copy.showroom,'showroom'));
    if(type && !this.querySelector('[role="alert"]')) type.value = resolved;
    const original = this.querySelector('[data-original-type]');
    if(original && ['hospitality','corporate','productie','showroom'].includes(normalized)) original.value = copy[normalized] || normalized;
    if(original && resolved==='showroom') original.value = copy.showroom;
    const context = this.querySelector('[data-product-context]');
    const product = (params.get('produs') || '').slice(0,180);
    const variant = (params.get('varianta') || '').slice(0,110);
    const sku = (params.get('sku') || '').slice(0,55);
    if(context && !context.value && product) {
     context.value = [product,variant && variant !== 'Default Title' ? variant : '',sku ? copy.sku+sku : ''].filter(Boolean).join(' · ').slice(0,330);
     if(optional) optional.open = true;
    }
    const ref = (params.get('referinta') || '').slice(0,180);
    const body = this.querySelector('textarea[name="contact[body]"]');
    if(ref && body && !body.value) body.value = copy.reference+ref+'\n\n';
    const update = () => {
     const hideBusiness = ['shop','showroom'].includes(type?.value);
     this.querySelectorAll('[data-business-field]').forEach(field=>{
      field.hidden=hideBusiness;
      field.querySelectorAll('input,select,textarea').forEach(input=>input.disabled=hideBusiness);
     });
     const trade=this.querySelector('[data-trade-note]');if(trade) trade.hidden=type?.value!=='trade';
     const white=this.querySelector('[data-white-label-note]');if(white) white.hidden=type?.value!=='white-label';
    };
    type?.addEventListener('change',()=>{if(original) original.value=type.value==='showroom'?copy.showroom:'';update();},options);
    update();
    this.addEventListener('invalid',event=>{const details=event.target.closest('details');if(details)details.open=true;},{...options,capture:true});
    const result=this.querySelector('[data-form-result]');if(result){result.tabIndex=-1;result.focus({preventScroll:true});}
   };
   if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{...options,once:true});else init();
  }
  disconnectedCallback(){this._controller?.abort();this._controller=null;this._initialized=false;}
 });
}
